import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';
import axios, { AxiosRequestConfig } from 'axios';
import useSWRMutation from 'swr/mutation';
import { useLogin } from '@hooks/auth/useLogin';

interface Reset {
  username: string;
}

interface Confirm extends Reset {
  confirmationCode: string;
  password: string;
}

interface Input {
  confirm: Confirm;
  reset: Reset;
}

type Path = keyof Input;

const { auth } = publicRuntimeConfig;

interface Key extends AxiosRequestConfig {
  login: ReturnType<typeof useLogin>['trigger'];
  path: Path;
}

const fetcher = async <T extends Path>(
  { login, path, ...key }: Key,
  { arg: input }: { arg: Input[T] },
) => {
  const data = await axios({
    ...key,
    data: input,
  });

  if (data.status === 200 && path === 'confirm') {
    const confirm = input as Confirm;
    await login({ username: confirm.username, password: confirm.password, rememberMe: true });
  }

  return data;
};

export const usePassword = <T extends Path>(path: T) => {
  const { trigger: login } = useLogin();

  return useSWRMutation(
    {
      url: `${auth?.url ?? ''}/passwords/${path}`,
      method: 'POST',
      login,
      path,
    },
    fetcher,
  );
};
